import withIcon from './NewIcon';
// @ts-ignore
import IconMapM from './icon/m/map.s.svg';

export default withIcon(IconMapM);
